import type { FinanceTranslations } from './types'

/**
 * Urdu translations for Finance domain
 * Comprehensive translations covering all UI text
 */
export const urTranslations: FinanceTranslations = {
  // Page/Section level
  title: "مالیات",
  subtitle: "مالیاتی آپریشنز کا انتظام کریں",
  overview: "مالیاتی جائزہ",
  invoices: "انوائسز",
  invoicesDescription: "انوائسز دیکھیں اور ان کا انتظام کریں",

  // Actions
  addFinance: "مالیاتی ریکارڈ شامل کریں",
  editFinance: "مالیاتی ریکارڈ میں ترمیم کریں",
  deleteFinance: "مالیاتی ریکارڈ حذف کریں",
  print: "پرنٹ کریں",
  downloadReceipt: "رسید ڈاؤن لوڈ کریں",

  // Search and filters
  searchPlaceholder: "لین دین تلاش کریں...",
  noItemsFound: "کوئی مالیاتی ریکارڈ نہیں ملا",
  noItemsDescription: "آپ نے ابھی تک کوئی مالیاتی ریکارڈ شامل نہیں کیا۔",
  addFirst: "اپنا پہلا مالیاتی ریکارڈ شامل کریں",

  // Transactions
  transactions: "لین دین",
  transactionsSubtitle: "تمام لین دین دیکھیں اور ان کا انتظام کریں",
  transactionHistory: "تاریخ لین دین",
  transactionNumber: "لین دین نمبر",
  transactionDetails: "لین دین کی تفصیلات",
  noTransactions: "کوئی لین دین نہیں",
  noTransactionsDescription: "آپ کے موجودہ فلٹرز سے کوئی لین دین میچ نہیں ہوتا۔",
  totalInvoiced: "کل انوائس شدہ",
  totalPaid: "کل ادا شدہ",
  outstanding: "بقایا",
  loadingCharge: "لوڈنگ چارج",
  paymentReceived: "ادائیگی موصول",

  // Transaction types
  type: "قسم",
  payment: "ادائیگی",
  invoice: "انوائس",
  credit: "کریڈٹ",
  debit: "ڈیبٹ",
  completed: "مکمل",
  failed: "ناکام",
  processing: "پروسیسنگ",

  // Transaction details
  description: "تفصیل",
  noDescription: "کوئی تفصیل فراہم نہیں کی گئی",
  date: "تاریخ",
  amount: "رقم",
  reference: "حوالہ",
  balanceAfter: "بعد کا بیلنس",
  actions: "اقدامات",

  // Statement
  statement: "اسٹیٹمنٹ",
  statementSubtitle: "اکاؤنٹ اسٹیٹمنٹ اور بیلنس کی تاریخ",
  noStatement: "کوئی اسٹیٹمنٹ نہیں",
  noStatementDescription: "منتخب مدت کے لیے کوئی اسٹیٹمنٹ ڈیٹا دستیاب نہیں۔",
  openingBalance: "ابتدائی بیلنس",
  closingBalance: "اختتامی بیلنس",
  netChange: "خالص تبدیلی",

  // Payments
  paymentsTitle: "ادائیگیاں",
  paymentsSubtitle: "اپنی ادائیگیوں اور کریڈٹ کا انتظام کریں",
  makePayment: "ادائیگی کریں",
  paymentAmount: "ادائیگی کی رقم",
  paymentMethod: "ادائیگی کا طریقہ",
  selectMethod: "ادائیگی کا طریقہ منتخب کریں",
  amountPlaceholder: "0.00",
  confirmPayment: "ادائیگی کی تصدیق کریں",
  recentPayments: "حالیہ ادائیگیاں",
  noPayments: "کوئی حالیہ ادائیگی نہیں",
  noPaymentsDescription: "موجودہ فلٹرز سے کوئی ادائیگی میچ نہیں ہوتی۔",
  searchPaymentsPlaceholder: "ادائیگیاں تلاش کریں...",
  allMethods: "تمام طریقے",
  paymentDetails: "ادائیگی کی تفصیلات",
  paymentNumber: "ادائیگی نمبر",
  sapReference: "SAP حوالہ",
  origin: "ماخذ",
  portalOrigin: "پورٹل",
  notes: "نوٹس",

  // Invoices
  invoicesTitle: "انوائسز",
  invoicesSubtitle: "SAP سے انوائسز دیکھیں",
  invoiceNumber: "انوائس نمبر",
  issueDate: "تاریخ",
  netAmountLabel: "خالص رقم",
  vatAmountLabel: "ٹیکس کی رقم",
  totalLabel: "کل",
  noInvoices: "کوئی انوائس نہیں",
  noInvoicesDescription: "موجودہ فلٹرز سے کوئی انوائس میچ نہیں ہوتی۔",
  searchInvoicesPlaceholder: "انوائسز تلاش کریں...",
  invoiceDetails: "انوائس کی تفصیلات",
  invoiceLines: "آئٹم لائنز",
  downloadPdf: "PDF ڈاؤن لوڈ کریں",
  printInvoice: "انوائس پرنٹ کریں",
  invoicePreviewTitle: "انوائس پیش نظارہ",
  invoicePreviewSubtitle: "ذیل میں انوائس دیکھیں۔ شیئر شدہ فائل PDF ہے۔",
  currency: "کرنسی",
  unitPrice: "فی یونٹ قیمت",
  lineTotal: "رقم",
  quantity: "مقدار",
  material: "مواد",
  lineDescription: "تفصیل",
  documentReference: "دستاویز حوالہ",
  sapCustomerCode: "کسٹمر کوڈ",
  salesOrganization: "سیلز آرگنائزیشن",
  documentType: "دستاویز کی قسم",
  amounts: "رقوم",

  // Credit
  creditAccount: "کریڈٹ اکاؤنٹ",
  availableCredit: "دستیاب کریڈٹ",
  creditLimit: "کریڈٹ کی حد",
  usedCredit: "استعمال شدہ کریڈٹ",

  // Due payments
  dueIn30Days: "30 دنوں میں واجب الادا",
  outstandingBalance: "بقایا بیلنس",

  // Payment methods
  viban: "وی آئی بی اے این",
  bankTransfer: "بینک ٹرانسفر",
  creditCard: "کریڈٹ کارڈ",
  vibanDesc: "ورچوئل آئی بی اے این کے ذریعے ادائیگی کریں",
  bankTransferDesc: "براہ راست بینک ٹرانسفر",
  creditCardDesc: "کریڈٹ کارڈ سے ادائیگی کریں",
  paymentMethods: "ادائیگی کے طریقے",

  // VIBAN
  yourViban: "آپ کا وی آئی بی اے این",
  copyViban: "وی آئی بی اے این کاپی کریں",
  copied: "کاپی ہو گیا!",
  vibanDescription: "اپنے اکاؤنٹ میں خودکار کریڈٹ کے لیے اس وی آئی بی اے این میں رقم منتقل کریں",

  // Stats
  receivable: "قابل وصول",
  payable: "قابل ادائیگی",
  pending: "زیر التوا",
  overdue: "واجب الادا",

  // Account status messages
  accountSuspended: "واجب الادا ادائیگیوں کی وجہ سے آپ کا اکاؤنٹ معطل ہے۔ براہ کرم حل کے لیے فنانس سے رابطہ کریں۔",
  accountBlocked: "آپ کا اکاؤنٹ بلاک ہے۔ براہ کرم فنانس ڈیپارٹمنٹ سے رابطہ کریں۔",

  // Payment methods (used with dynamic keys)
  methods: {
    viban: "وی آئی بی اے این ٹرانسفر",
    bank: "بینک ٹرانسفر",
    card: "کریڈٹ کارڈ",
    cash: "نقد",
    check: "چیک",
    bank_transfer: "بینک ٹرانسفر",
    credit_card: "کریڈٹ کارڈ",
    sadad: "سداد",
  },

  // Form section
  form: {
    name: "ریکارڈ کا نام",
    namePlaceholder: "ریکارڈ کا نام درج کریں",
    status: "حالت",
    validation: {
      nameRequired: "ریکارڈ کا نام درکار ہے",
    }
  },

  // Status
  status: {
    active: "فعال",
    inactive: "غیر فعال",
  },

  // Messages
  messages: {
    createSuccess: "مالیاتی ریکارڈ کامیابی سے بنایا گیا",
    updateSuccess: "مالیاتی ریکارڈ کامیابی سے اپ ڈیٹ ہوا",
    deleteSuccess: "مالیاتی ریکارڈ کامیابی سے حذف ہوا",
    deleteConfirm: "کیا آپ واقعی اس مالیاتی ریکارڈ کو حذف کرنا چاہتے ہیں؟",
  },

  // Table headers
  table: {
    name: "نام",
    status: "حالت",
  },

  // Top-level convenience keys
  name: "نام",
  namePlaceholder: "ریکارڈ کا نام درج کریں",
  statusLabel: "حالت",
  nameRequired: "ریکارڈ کا نام درکار ہے",
  active: "فعال",
  inactive: "غیر فعال",
  createSuccess: "مالیاتی ریکارڈ کامیابی سے بنایا گیا",
  updateSuccess: "مالیاتی ریکارڈ کامیابی سے اپ ڈیٹ ہوا",
  deleteSuccess: "مالیاتی ریکارڈ کامیابی سے حذف ہوا",
  deleteConfirm: "کیا آپ واقعی اس مالیاتی ریکارڈ کو حذف کرنا چاہتے ہیں؟",

  // SAP Balances
  currentBalance: "موجودہ بیلنس",
  availableContractBalance: "دستیاب بیلنس",
  lastSynced: "آخری مزامنت",
  syncing: "مزامنت ہو رہی ہے...",

  // Retry SAP sync
  retrySapSync: "SAP مزامنت دوبارہ کریں",
  syncingPayment: "مزامنت ہو رہی ہے...",
  retrySapSyncDescription: "اس ادائیگی کو SAP کو دوبارہ بھیجیں",

  // Payment method top-level keys
  bank: "بینک ٹرانسفر",
  card: "کریڈٹ کارڈ",
  cash: "نقد",
  check: "چیک",
}
